import { useEffect, useRef } from 'react';

export const useClearFilesOnConversationChange = (
  currentConversationId: string | null,
  clearFiles: () => void
) => {
  const previousConversationIdRef = useRef(currentConversationId);

  useEffect(() => {
    const previous = previousConversationIdRef.current;
    previousConversationIdRef.current = currentConversationId;
    if (previous !== null && previous !== currentConversationId) {
      clearFiles();
    }
  }, [currentConversationId, clearFiles]);
};
